import React, { useEffect, useRef } from 'react'
import CloseIcon from '../../../../assets/icons/actions/close.svg'
import Button from "../../Buttons";

function ModalComponent({
  title,
  children,
  setOpenModal,
  setCancelModal,
  icon,
  openEditModal,
  setSelectedVariant,
  setOpenEditModal,
  createLoading,
  updateLoading,
  onCreate,
  onUpdate,
  loading
}) {
  const modalRef = useRef(null)

  const handleClose = () => {
    if (createLoading || updateLoading || loading) return;
    setOpenModal(false);
    setOpenEditModal(false);
    if (typeof setSelectedVariant === 'function') {
      setSelectedVariant(null);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        if (!createLoading && !updateLoading && !loading) {
          setOpenModal(false);
          setCancelModal(false);
          setOpenEditModal(false);
          if (typeof setSelectedVariant === 'function') {
            setSelectedVariant(null);
          }
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [setOpenModal, setCancelModal, setOpenEditModal, createLoading, updateLoading, loading, setSelectedVariant]);

  useEffect(() => {
    const originalStyle = window.getComputedStyle(document.body).overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = originalStyle;
    };
  }, []);

  return (
    <div>
      <div className="w-full h-full fixed top-0 left-0 z-10 bg-[#000] opacity-60"></div>

      <div
        ref={modalRef}
        className="w-[340px] sm:w-[640px] max-w-[calc(100vw-1.5rem)] sm:max-w-[calc(100vw-2rem)] rounded-[26px] max-h-[90vh] overflow-x-hidden bg-[#fff] pb-10 shadow-2xl !z-20 fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
      >
        <div
          onClick={!createLoading && !updateLoading && !loading ? handleClose : undefined}
          className="absolute top-5 right-5"
        >
          <img
            src={CloseIcon}
            alt="CloseIcon"
            className={`w-3 h-3 sm:w-5 sm:h-5 ${(createLoading || updateLoading || loading) ? "cursor-not-allowed" : "cursor-pointer"}`}
          />
        </div>

        <h4
          className={`add-modal m-0 ${
            openEditModal ? 'pt-[24px] sm:pt-[28px]' : 'pt-[40px]'
          }`}
        >
          {title}
        </h4>

        {icon && (
          <img
            src={icon}
            alt="icon"
            className="flex justify-center items-center mx-auto mt-[-40px] sm:mt-[-60px]"
          />
        )}

        {children}

        {!openEditModal ? (
          <div className="flex justify-center items-center gap-x-4 mt-8">
            <Button
              type="button"
              primaryOutline
              onClick={handleClose}
              disabled={createLoading || updateLoading || loading}
              className="action_btn"
            >
              Cancel
            </Button>
            <Button
              loading={createLoading}
              onClick={() => onCreate()}
              className="action_btn cursor-pointer"
            >
              Save
            </Button>
          </div>
        ) : (
          <div className="flex justify-center items-center gap-x-4 mt-2 sm:mt-3">
            <Button
              type="button"
              primaryOutline
              disabled={createLoading || updateLoading || loading}
              onClick={handleClose}
              className="action_btn !w-[40%]"
            >
              Cancel
            </Button>
            <Button
              type="button"
              onClick={() => onUpdate()}
              loading={updateLoading || loading}
              disabled={updateLoading || loading}
              className="action_btn !w-[40%] cursor-pointer"
            >
              Update
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}

export default ModalComponent;
